import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Button, EmptyState, Typography } from 'shared/ui'
import { useSectionConversationContext } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation/context/sectionConversationContext'
import styles from './styles.module.scss'

export const NotFound = observer(() => {
  const { notFoundText, openCount, filtersStore } = useSectionConversationContext()

  const renderContent = () => {
    return (
      <Typography className={styles.wrap__text} ariaLabel={'not_found'} variant={'body-rg-medium'}>
        {notFoundText}
      </Typography>
    )
  }

  if (openCount) {
    if (filtersStore.filter.key === 'open') {
      return <div className={styles.wrap}>{renderContent()}</div>
    }

    return (
      <div className={classnames(styles.wrap, styles['wrap--empty'])}>
        <EmptyState
          variant='default'
          title={notFoundText}
          text={`You have ${openCount} open ${openCount > 1 ? 'conversations' : 'conversation'}`}
          typographyProps={{
            variant: 'body-md-regular',
            ariaLabel: 'EmptyState',
          }}
          noIcon
          actions={
            <>
              <Button
                text={'Switch to open'}
                onClick={() => {
                  filtersStore.setFilter('open')
                }}
                size={'medium'}
                typeBtn={'contained'}
                contained={'secondary'}
              />
            </>
          }
        />
      </div>
    )
  }

  return <div className={styles.wrap}>{renderContent()}</div>
})
